module.exports = __webpack_public_path__ + "static/media/fonts-5-mobile.61cafda0.svg";